export const CARD_BACK_WIDTH = 280; // Black background for each card
export const CARD_BACK_HEIGHT = 280;
export const CARD_BORDER_ROUND_PX = 25; // How many px to round card border
export const WINDOW_WIDTH = 1022; // Width of window (breakpoint to start scaling card)
